import React from 'react';

export const UserActivation = React.lazy(() => import('./pages/UserActivation'));
export const EventUserRegistration = React.lazy(() => import('./pages/EventUserRegistration'));
